import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  HostListener
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {
  ROLE,
  statusCode,
  STATUSCODESTRING,
  CompName,
} from '@shared/helpers/constants';
import { AuthService } from '../../shared/services/auth.service';
import { constantStrings } from '@shared/helpers/constants';
import { CasefilterdialogComponent } from '../casefilterdialog/casefilterdialog.component';
import { CaseHistoryData } from '@shared/models/user.model';
import { CasedashboardService } from '../casedashboard.service';
import { SharedStateService } from '@shared/services/shared-state.service';
import { formatDate } from '@angular/common';
import { StorageService } from '@shared/services/storage.service';

export interface DialogData {
  compName: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  searchText: any;
  errInfoFlag: boolean = false;
  infoFlag: boolean = false;
  errFlag: boolean = false;
  redFlag: boolean = false;
  greenFlag: boolean = false;
  timeFlag: boolean = false;
  searchFlag: boolean = true;
  filterFlag: boolean = true;
  caseCompFlag: boolean = false;
  caseDBData: CaseHistoryData;
  pagelimit = constantStrings.PageLimit;
  assignedArr: any = [];
  userDetails: any;
  loggedinUserName: string;
  imageurl: string;
  anatomy: string | undefined;
  type: string | undefined;
  assigned: string | undefined;
  status: string | undefined;
  isDisabled = false;
  loggedInUser: string | undefined;
  userInfo: any;
  managerFlag: boolean = false;
  reviewerFlag: boolean = false;
  @Output() searchClick = new EventEmitter();
  @Output() iconClick = new EventEmitter();
  @Output() filterClick = new EventEmitter();
  @Input() componentName: string;
  isErrorChecked: boolean = false;
  isInfoChecked: boolean = false;
  isGreenFlagChecked: boolean = false;
  isRedFlagChecked: boolean = false;
  isDayFlagChecked: boolean = false;
  selectedanatomy: any = [];
  selectedtype: any = [];
  selectedassigned: any = [];
  selectedimagecenter: any = [];
  selectedstatus: any = [];
  selectedDueDateStart: Date | null;
  selectedDueDateEnd: Date | null;
  selectedComplDateStart: Date | null;
  selectedComplDateEnd: Date | null;
  completeddateGradient: boolean = true;
  anatomyGradient: boolean = true;
  assignedGradient: boolean = true;
  imagecenterGradient: boolean = true;
  typeGradient: boolean = true;
  statusGradient: boolean = true;
  duedateGradient: boolean = true;
  filterActive: boolean = false;
  public showCaseModal: boolean = false;
  public today: Date = new Date();
  @ViewChild('searchInp') searchInput: ElementRef;
  auditAction: any;
  @ViewChild('filterContainer') filterContainer: ElementRef;
  isOverflowing: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isOverflowing = this.casedashboardService.customEllipsisHandler(this.filterContainer);
  }

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private authService: AuthService,
    private sharedState: SharedStateService,
    private casedashboardService: CasedashboardService,
    private storageService: StorageService
  ) {}
  ngOnInit(): void {
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe((response) => {
      this.auditAction = response;
    });
    const idToken = this.authService.getCognitoAccessTokenFromStorage();
    const decodedValue = this.authService.decode(idToken);
    this.loggedInUser = decodedValue ? decodedValue['cognito:groups'][0] : '';
    if (this.loggedInUser == ROLE.SNN_HIL_MANAGER) {
      this.managerFlag = true;
    } else if (this.loggedInUser == ROLE.SNN_HIL_REVIEWER) {
      this.reviewerFlag = true;
    }

    switch (this.componentName) {
      case CompName.CASEHISTORY:
        this.errInfoFlag = true;
        this.caseCompFlag = true;

        break;
      case CompName.MYCASES:
        this.errFlag = true;
        this.redFlag = true;
        this.timeFlag = true;
        break;
      case CompName.SETTINGS:
        this.searchFlag = false;
        this.filterFlag = false;
        this.infoFlag = false;
        this.errInfoFlag = false;
        break;
      default:
        this.infoFlag = true;
        this.redFlag = true;
        this.greenFlag = true;
        this.timeFlag = true;
        break;
    }
    this.caseDBData = {
      page: 0,
      limit: this.pagelimit,
      column: null,
      sortOrder: '',
      searchText: '',
      anatomy: [],
      sourceFacilityId: [],
      caseStatus: [],
      claimantUserName: [],
      imagingType: [],
      fromDueDate: null,
      toDueDate: null,
      fromUpdatedDate: null,
      toUpdatedDate: null,
    };
    this.sharedState.loginStateData$.subscribe((response) => {
      if (this.authService.getItem('userDetails')) {
        this.userDetails = this.authService.getItem('userDetails');
        if (
          this.userDetails?.userFirstName != undefined &&
          this.userDetails?.userLastName != undefined
        ) {
          this.loggedinUserName =
            this.userDetails?.userFirstName.slice(0, 1) +
            ' ' +
            this.userDetails?.userLastName;
        }
        this.imageurl = this.userDetails?.profileImageUrl;
        this.casedashboardService.loggedInUserName = this.userDetails?.userName;
        this.casedashboardService.loggedInUserFirstName =
        this.storageService.removeHtml(this.userDetails?.userFirstName);
        this.casedashboardService.loggedUserLastName =
        this.storageService.removeHtml(this.userDetails?.userLastName);
      }
    });
    if (this.casedashboardService.storedData != undefined)
      this.clearServiceFilter();
  }
  //This method is called to open Filter modal
  public openFilter(): void {
    let dialogRef = this.dialog.open(CasefilterdialogComponent, {
      autoFocus: false,
      id: 'headerfilter',
      disableClose: true,
      position: { right: '0', top: '100px' },
      data: { compName: this.componentName },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.displayFilterItems(result);
      setTimeout(() => {
        this.isOverflowing = this.casedashboardService.customEllipsisHandler(this.filterContainer);
      }, 0);
    });
  }
  /**
   * This function filters items based on user-selected criteria and emits the filtered data.
   */
  displayFilterItems(result) {
    this.isErrorChecked = false;
    this.isInfoChecked = false;
    this.isGreenFlagChecked = false;
    this.isRedFlagChecked = false;
    this.isDayFlagChecked = false;

    this.clearFilterArray();
    if (result?.anatomy) {
      result.anatomy.forEach((item) => {
        if (
          item.isSelected == true &&
          !this.caseDBData.anatomy.includes(item.anatomyId)
        ) {
          this.selectedanatomy.push(item);
          this.caseDBData.anatomy.push(item.anatomyId);
        }
      });
    }

    if (result?.type) {
      result.type.forEach((item) => {
        if (
          item.isSelected == true &&
          !this.caseDBData.imagingType.includes(item.typeId)
        ) {
          this.selectedtype.push(item);
          this.caseDBData.imagingType.push(item.typeId);
        }
      });
    }

    if (result?.status) {
      result.status.forEach((item) => {
        if (
          item.isSelected == true &&
          !this.caseDBData.caseStatus.includes(item.statusId)
        ) {
          this.selectedstatus.push(item);
          this.caseDBData.caseStatus.push(item.statusId);
        }
      });
    }

    if (result?.assigned) {
      this.assignedArr = result.assigned;
      result.assigned.forEach((item) => {
        if (
          item.isSelected == true &&
          !this.caseDBData.claimantUserName.includes(item.assignedId)
        ) {
          this.selectedassigned.push(item);
          this.caseDBData.claimantUserName.push(item.assignedId);
        }
      });
    }

    if (result?.imagecenter) {
      result.imagecenter.forEach((item) => {
        if (
          item.isSelected == true &&
          !this.caseDBData.sourceFacilityId.includes(item.imagecenterId)
        ) {
          this.selectedimagecenter.push(item);
          this.caseDBData.sourceFacilityId.push(item.imagecenterId);
        }
      });
    }
    if (result?.duedateStart) {
      this.selectedDueDateStart = result.duedateStart;
    }
    if (result?.duedateEnd) {
      this.selectedDueDateEnd = result.duedateEnd;
    }
    if (result?.duedateStart && result?.duedateEnd == undefined) {
      this.selectedDueDateStart = result.duedateStart;
      this.selectedDueDateEnd = this.today;
      this.duedateGradient = false;
    }
    if (result?.completedateStart) {
      this.selectedComplDateStart = result.completedateStart;
    }
    if (result?.completedateEnd) {
      this.selectedComplDateEnd = result.completedateEnd;
    }
    if (result?.completedateStart && result?.completedateEnd == undefined) {
      this.selectedComplDateStart = result.completedateStart;
      this.selectedComplDateEnd = this.today;
      this.completeddateGradient = false;
    }
    this.caseDBData.fromDueDate =
      this.selectedDueDateStart != undefined
        ? this.formatedDate(
            this.selectedDueDateStart,
            constantStrings.STARTDATE
          )
        : null;
    this.caseDBData.toDueDate =
      this.selectedDueDateEnd != undefined
        ? this.formatedDate(this.selectedDueDateEnd, constantStrings.ENDDATE)
        : null;
    this.caseDBData.fromUpdatedDate =
      this.selectedComplDateStart != undefined
        ? this.formatedDate(
            this.selectedComplDateStart,
            constantStrings.STARTDATE
          )
        : null;
    this.caseDBData.toUpdatedDate =
      this.selectedComplDateEnd != undefined
        ? this.formatedDate(this.selectedComplDateEnd, constantStrings.ENDDATE)
        : null;
    this.filterActiveFlag();
    this.filterClick.emit(this.caseDBData);
  }
  /**
   * This function deletes selected filters from a case dashboard and updates the stored data
   * accordingly.
   */
  deleteFilter(item, id) {
    if (id == constantStrings.ANATOMY) {
      for (let anatomy of this.selectedanatomy) {
        if (item == anatomy) {
          this.caseDBData.anatomy.splice(
            this.selectedanatomy.indexOf(anatomy),
            1
          );
          this.selectedanatomy.splice(this.selectedanatomy.indexOf(anatomy), 1);
          for (let anatomyData of this.casedashboardService.storedData
            .anatomy) {
            if (anatomyData.anatomyId == item.anatomyId) {
              anatomyData.isSelected = false;
            }
          }
        }
      }
    }

    if (id == constantStrings.ASSIGNED) {
      for (let assigned of this.selectedassigned) {
        if (item.assignedId == assigned.assignedId) {
          let index = this.caseDBData.claimantUserName.indexOf(item.assignedId);
          if (index >= 0) {
            this.caseDBData.claimantUserName.splice(index, 1);
          }
        }
        if (item == assigned) {
          this.selectedassigned.splice(
            this.selectedassigned.indexOf(assigned),
            1
          );
        }
        for (let assignedData of this.casedashboardService.storedData
          .assigned) {
          if (assignedData.assignedId == item.assignedId) {
            assignedData.isSelected = false;
          }
        }
      }
    }
    if (id == constantStrings.TYPES) {
      for (let type of this.selectedtype) {
        if (item == type) {
          this.caseDBData.imagingType.splice(
            this.selectedanatomy.indexOf(type),
            1
          );
          this.selectedtype.splice(this.selectedtype.indexOf(type), 1);
          for (let typeData of this.casedashboardService.storedData.type) {
            if (typeData.typeId == item.typeId) {
              typeData.isSelected = false;
            }
          }
        }
      }
    }
    if (id == constantStrings.STATUS) {
      for (let status of this.selectedstatus) {
        if (item.status == STATUSCODESTRING.statusNew) {
          let index = this.caseDBData.caseStatus.indexOf(statusCode.NEW);
          if (index >= 0) {
            this.caseDBData.caseStatus.splice(index, 1);
          }
        }
        if (item.status == STATUSCODESTRING.statusRejected) {
          let index = this.caseDBData.caseStatus.indexOf(statusCode.REJECTED);
          if (index >= 0) {
            this.caseDBData.caseStatus.splice(index, 1);
          }
        }
        if (item.status == STATUSCODESTRING.statusApproved) {
          let index = this.caseDBData.caseStatus.indexOf(statusCode.APPROVED);
          if (index >= 0) {
            this.caseDBData.caseStatus.splice(index, 1);
          }
        }
        if (item.status == STATUSCODESTRING.statusInProgress) {
          const INPROGRESS_STATUS_LIST = [statusCode.INREVIEW, statusCode.BONE_MODEL_INITIATED];

          INPROGRESS_STATUS_LIST.forEach(code => {
            let index = this.caseDBData.caseStatus.indexOf(code);
            if (index >= 0) {
              this.caseDBData.caseStatus.splice(index, 1);
            }
          });
        }
        if (item.status == STATUSCODESTRING.statusError) {
          let index = this.caseDBData.caseStatus.indexOf(statusCode.ERROR);
          if (index >= 0) {
            this.caseDBData.caseStatus.splice(index, 1);
          }
        }
        if (item.status == STATUSCODESTRING.statusUnclaimed) {
          let index = this.caseDBData.caseStatus.indexOf(statusCode.UNCLAIMED);
          if (index >= 0) {
            this.caseDBData.caseStatus.splice(index, 1);
          }
        }
        if (item.status == STATUSCODESTRING.statusProcessing) {
          let index = this.caseDBData.caseStatus.indexOf(
            statusCode.BONE_MODEL_INITIATED
          );
          if (index >= 0) {
            this.caseDBData.caseStatus.splice(index, 1);
          }
        }
        if (item == status) {
          this.selectedstatus.splice(this.selectedstatus.indexOf(status), 1);
        }
        for (let statusData of this.casedashboardService.storedData.status) {
          if (statusData.statusId == item.statusId) {
            statusData.isSelected = false;
          }
        }
      }
    }
    if (id == constantStrings.IMAGECENTER) {
      for (let imagecenter of this.selectedimagecenter) {
        if (item == imagecenter) {
          this.caseDBData.sourceFacilityId.splice(
            this.selectedimagecenter.indexOf(imagecenter),
            1
          );
          this.selectedimagecenter.splice(
            this.selectedimagecenter.indexOf(imagecenter),
            1
          );
          for (let center of this.casedashboardService.storedData.imagecenter) {
            if (center.imagecenter == item.imagecenter) {
              center.isSelected = false;
            }
          }
        }
      }
    } else if (
      id == constantStrings.STARTDATE ||
      id == constantStrings.ENDDATE
    ) {
      this.selectedComplDateStart = null;
      this.selectedComplDateEnd = null;
      this.caseDBData.fromUpdatedDate = null;
      this.caseDBData.toUpdatedDate = null;
      this.casedashboardService.storedData.completedateEnd = null;
      this.casedashboardService.storedData.completedateStart = null;
    } else if (
      id == constantStrings.STARTDATEDUE ||
      id == constantStrings.ENDDATEDUE
    ) {
      this.selectedDueDateStart = null;
      this.selectedDueDateEnd = null;
      this.caseDBData.fromDueDate = null;
      this.caseDBData.toDueDate = null;
      this.casedashboardService.storedData.duedateStart = null;
      this.casedashboardService.storedData.duedateEnd = null;
    }
    this.filterActiveFlag();
    this.filterClick.emit(this.caseDBData);
    this.isOverflowing = this.casedashboardService.customEllipsisHandler(this.filterContainer);
  }
  /**
   * The function checks if any filters are active and sets a boolean flag accordingly.
   */
  filterActiveFlag() {
    if (
      this.selectedanatomy.length > 0 ||
      this.selectedtype.length > 0 ||
      this.selectedstatus.length > 0 ||
      this.selectedassigned.length > 0 ||
      this.selectedimagecenter.length > 0 ||
      this.selectedDueDateStart ||
      this.selectedDueDateEnd ||
      this.selectedComplDateStart ||
      this.selectedComplDateEnd
    ) {
      this.filterActive = true;
    } else {
      this.filterActive = false;
    }
  }
  /**
   * The function clears all selected filters and resets the corresponding data in the caseDBData object.
   */
  clearFilterArray() {
    this.selectedDueDateStart = null;
    this.selectedDueDateEnd = null;
    this.selectedComplDateStart = null;
    this.selectedComplDateEnd = null;
    this.selectedanatomy = [];
    this.caseDBData.anatomy = [];
    this.selectedtype = [];
    this.caseDBData.imagingType = [];
    this.selectedstatus = [];
    this.caseDBData.caseStatus = [];
    this.selectedassigned = [];
    this.caseDBData.claimantUserName = [];
    this.selectedimagecenter = [];
    this.caseDBData.sourceFacilityId = [];
  }
  /**
   * The function clears the filter and related data in a dashboard service.
   */
  clearFilter() {
    this.filterActive = false;
    this.clearFilterArray();
    this.casedashboardService.ClearFilterData();
  }
  /**
   * The function clears the filter and related data in a dashboard service storedData.
   */
  clearServiceFilter() {
    this.casedashboardService.storedData.completedateEnd = undefined;
    this.casedashboardService.storedData.completedateStart = undefined;
    this.casedashboardService.storedData.duedateStart = undefined;
    this.casedashboardService.storedData.duedateEnd = undefined;
    this.casedashboardService.storedData.imagecenter = [];
    this.casedashboardService.storedData.assigned = [];
    this.casedashboardService.storedData.status = [];
    this.casedashboardService.storedData.anatomy = [];
    this.casedashboardService.storedData.type = [];
  }
  isDisable() {
    this.isDisabled = true;
  }
  /**
   * This function logs out the user and clears their authentication.
   */
  public userLogout(): void {
    this.authService.auditLogOutActivity(
      this.auditAction.UserActions.logoutSuccess
    );
    this.authService.signOut();
    this.authService.clear();
  }
  /**
   * This function Exits the user to the CLP Product screen.
   */
  public exitToApp(): void {
    this.authService.exitToApp();
  }
  /**
   * This function emits an event with the search text as a parameter.
   */
  searchRecord() {
    this.searchClick.emit(this.searchText);
  }

  enterClicks() {
    this.searchClick.emit(this.searchText);
  }
  /**
   * This function clears the filter and toggles the isErrorChecked flag while emitting an iconClick
   * event.
   */
  searchRejectedRecord() {
    this.clearFilter();
    this.isErrorChecked = !this.isErrorChecked;
    this.isInfoChecked = false;
    this.isGreenFlagChecked = false;
    this.isRedFlagChecked = false;
    this.isDayFlagChecked = false;
    this.iconClick.emit({ isErrorChecked: this.isErrorChecked });
  }
  /**
   * The function clears the filter, toggles a boolean value, and emits an event with the updated
   * boolean value.
   */
  searchNewRecord() {
    this.clearFilter();
    this.isInfoChecked = !this.isInfoChecked;
    this.isErrorChecked = false;
    this.isGreenFlagChecked = false;
    this.isRedFlagChecked = false;
    this.isDayFlagChecked = false;
    this.iconClick.emit({ isInfoChecked: this.isInfoChecked });
  }
  /**
   * This function clears the filter and toggles the value of a boolean variable, then emits an event
   * with the updated value.
   */
  searchReviewRec() {
    this.clearFilter();
    this.isGreenFlagChecked = !this.isGreenFlagChecked;
    this.isInfoChecked = false;
    this.isErrorChecked = false;
    this.isRedFlagChecked = false;
    this.isDayFlagChecked = false;
    this.iconClick.emit({ isGreenFlagChecked: this.isGreenFlagChecked });
  }
  /**
   * This function clears filters and emits an event with a boolean value indicating whether a red flag
   * is checked or not.
   */
  searchOverDueRec() {
    this.clearFilter();
    this.isRedFlagChecked = !this.isRedFlagChecked;
    this.isGreenFlagChecked = false;
    this.isInfoChecked = false;
    this.isErrorChecked = false;
    this.isDayFlagChecked = false;
    this.iconClick.emit({ isRedFlagChecked: this.isRedFlagChecked });
  }
  /**
   * This function clears the filter and emits an event with a boolean value indicating whether a day
   * flag is checked or not.
   */
  searchonDayUntilDueRec() {
    this.clearFilter();
    this.isDayFlagChecked = !this.isDayFlagChecked;
    this.isRedFlagChecked = false;
    this.isGreenFlagChecked = false;
    this.isInfoChecked = false;
    this.isErrorChecked = false;
    this.iconClick.emit({ isDayFlagChecked: this.isDayFlagChecked });
  }
  /**
   * The function formats a given date string into a UTC date time value.
   * @param str - A string representing a date in the format "YYYY-MM-DD".
   * @param dateFlag - A string representing a start date or end date Flag.
   * @returns a formatted date string in the format "MM/DD/YYYY HH:mm:ss in 24hours".
   */
  formatedDate(str, dateFlag) {
    if (str == null) return null;
    let newStr = new Date(str);
    let changedUtcDate;
    if (str && dateFlag == constantStrings.STARTDATE) {
      let utcStartTime = new Date(
        newStr.getTime() + newStr.getTimezoneOffset() * 60000
      );
      changedUtcDate = utcStartTime.toISOString();
    } else if (str && dateFlag == constantStrings.ENDDATE) {
      newStr.setHours(0, 0, 0, 0);
      let endOfDay =
        newStr.getTime() +
        (24 * 60 * 60 * 1000 - 1) +
        newStr.getTimezoneOffset() * 60000;
      changedUtcDate = new Date(endOfDay).toISOString();
    }
    let formatedDate = formatDate(
      changedUtcDate,
      'MM/dd/yyyy HH:mm:ss',
      'en-US'
    );
    return formatedDate;
  }
  focusOnSearchInput() {
    this.searchInput.nativeElement.focus();
  }
}
